import httpClient, { isHttpError } from '../httpClient';

export async function getTed(id: string) {
  try {
    const response = await httpClient.get(`/api/ted/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function getAllTeds() {
  try {
    const response = await httpClient.get(`/api/ted`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}

export async function getTedsByUsuario() {
  try {
    const response = await httpClient.get(`/api/ted/teds-por-usuario`);

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter TEDs do usuário: ' + error);
  }
}

export async function createTed(tedData: any) {
  const response = await httpClient.post(`/api/ted/`, tedData);
  return response;
}

export const updateTed = async (id: string, data: any): Promise<any> => {
  try {
    const response = await httpClient.patch(`/api/ted/${id}`, data);
    return response;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao atualizar TED.',
      );
    }
    throw error;
  }
};

export const deleteTed = async (id: string): Promise<any> => {
  try {
    const response = await httpClient.delete(`/api/ted/${id}`);
    return response;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao deletar TED.');
    }
    throw error;
  }
};
